/**
 * Investment Selection Payment Methods Component
 ****************************************
 *
 * @version 1.0.1
 * @author Karibandi Lalitha
 * @description This component returns the personal check offline  payment methods
 * @createdDate [24/03/2020]
 * ***************************************
 * @lastModifiedDate
 * @lastModifiedBy
 * @lastModifiedReason
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { WCard } from '../../../common';
import consts from './constants';
import './confirmAccountOpening.css';

const PersonalCheckComponent = props => {
    const { heading } = props;
    const {
        personalCheckMsg1,
        personalCheckMsg2,
        personalCheckMsg3,
        specimen,
        displayNoneStyle,
        specimentTitleStyle,
        wireTransferMailingAddressHeading,
        wireTransferMailingAddressText,
        wireTransferCardTextStyle,
        wireTransferCardBodyStyle,
        wireTransferTitleStyle,
    } = consts;
    return (
        <div className="dividendHint fundingTypecard">
            <Row noGutters className="sectionHeader">
                <Col xs={12}>
                    <h3 className="sectionHeading">{heading}</h3>
                </Col>
            </Row>
            <Row noGutters>
                <Col xs={12}>
                    <p>{personalCheckMsg1}</p>
                    <p className="boldPara">{personalCheckMsg2}</p>
                </Col>
            </Row>
            <Row noGutters className="fundTypeSpecimenWrapper">
                <Col xs={8}>
                    <div className="specimenCardWrapper checkSpecimen">
                        <WCard
                            alt="Sample for personal check"
                            className="specimenCard"
                            buttonstyle={displayNoneStyle}
                            src={'/assets/check-specimen.png'}
                            cardtitletext={specimen}
                            cardtitlestyle={specimentTitleStyle}
                            linkcard="true"
                        />
                    </div>
                </Col>
                <Col xs={4}>
                    <div className="specimenCardWrapper">
                        <WCard
                            className="specimenCard wireTransferCard new-line"
                            buttonstyle={displayNoneStyle}
                            cardtitletext={wireTransferMailingAddressHeading}
                            cardtext={wireTransferMailingAddressText}
                            cardtextstyle={wireTransferCardTextStyle}
                            cardbodystyle={wireTransferCardBodyStyle}
                            cardtitlestyle={wireTransferTitleStyle}
                            linkcard="true"
                            alt=""
                            src=""
                        />
                    </div>
                </Col>
            </Row>
            <Row noGutters>
                <Col xs={12}>
                    <p>{personalCheckMsg3}</p>
                </Col>
            </Row>
        </div>
    );
};

PersonalCheckComponent.propTypes = {
    heading: PropTypes.string,
};

PersonalCheckComponent.defaultProps = {
    heading: 'heading',
};

export default memo(PersonalCheckComponent);
